<template>
    <span class="close-loader"></span>
</template>

<script>
export default {}
</script>

<style lang="scss">
.close-loader {
    width: 20px;
    height: 20px;
    border: 5px solid #333;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>